import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { CanonicalService } from '../shared/canonical.service';
import { NiceScrollService } from '../_services/nice-scroll.service';

@Component({
    selector: 'app-about-us',
    templateUrl: './about-us.component.html',
    styleUrls: ['./about-us.component.css'],
    standalone: false
})
export class AboutUsComponent implements OnInit {

  constructor(private titleService: Title,
              private canonicalService: CanonicalService,
              private niceScroll: NiceScrollService
              ) {
                niceScroll.scrollToTop();
              }

  ngOnInit() {
    this.titleService.setTitle('About Us | Buy, Sell, Rent Homes & Properties in Pakistan | pakmatti.com');
    this.canonicalService.setCanonicalURL();
  }

}
